import React, { Component  } from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { withTranslation } from "react-i18next";
import _ from "lodash";
import {
  Col, Container, Row
} from "reactstrap";

import InferenceForm from "./InferenceForm";
import { createOrUpdateInference } from "../../../redux/actions/inferenceActions";
import { loadCollections } from "../../../redux/actions/collections";
import {
  getAiModelsInference
} from "../../../redux/actions/inferenceActions";

export class InferenceCreateUpdate extends Component {

  componentDidMount() {
    this.props.loadCollections();
    this.aiModel = []
  }
   closeForm = () => {
    this.props.history.push("/inference");
  };

  handleCreate = (data) => {
    if ( data && Object.keys(data).length > 0 ) {
      data.ai_model_list = this.aiModel || [];
      const collection = _.find(this.props.collections, ['collection_name', data.collection_name]);
      if(collection && collection._id) {
        data.collection_id = collection._id
      }
      data.storageType =  data.storageType.value;
      data.activity_status =  data.activity_status.value;
      data.collection_name =  data.collection_name.label;

      if(data.ai_model_list && data.ai_model_list.length > 0) {
        _.map(data.ai_model_list, ai_model => {
          return ai_model.monitoring_window = parseInt(data[`monitoring_window${ai_model._id}`]);
        });
      }

      if(data.ai_model_list && data.ai_model_list.length > 0) {
        _.map(data.ai_model_list, ai_model => {
          return ai_model.execution_type = data[`execution_type${ai_model._id}`]['value'];
        });
      }

      delete data.formType;
      delete data.collection_name;
      delete data.updated_health_status;
      delete data.owner;
      _.forEach(data, function(value, key) {
        if(key.search('execution_type') === 0) {
          delete data[key];
        }

        if(key.search('monitoring_window') === 0) {
          delete data[key];
        }
      });

      this.props.createOrUpdateInference(data, this.props.history);
    }

  };

  renderField =
    ({
       input, placeholder, type, meta: { touched, error },
     }) => (
      <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
        <input {...input} placeholder={placeholder} type={type} />
        {touched && error && <span className="form__form-group-error">{error}</span>}
      </div>
    );

  setAiModel = aiModel => {
      this.aiModel = aiModel;
  }

  build_selected_Inference = selectedInference => {
    let newSelectedInference = JSON.parse(JSON.stringify(selectedInference));

    if(newSelectedInference && Object.keys(newSelectedInference).length > 0) {

      if (newSelectedInference.activity_status) {
        newSelectedInference.activity_status = {
          value: newSelectedInference.activity_status,
          label: newSelectedInference.activity_status.replace(/_/g, ' ')
        };
      }

      if (newSelectedInference.storageType) {
        newSelectedInference.storageType = {
          value: newSelectedInference.storageType,
          label: newSelectedInference.storageType
        };
      }

      if (newSelectedInference.ai_model_list) {
        _.map(newSelectedInference.ai_model_list, i => {
          newSelectedInference[`execution_type${i._id}`] =
            { value: i.execution_type, label: i.execution_type };
          newSelectedInference[`monitoring_window${i._id}`] = i.monitoring_window;
        })
      }
    }

    return newSelectedInference;
  };

  render () {
    const { t, selectedInference, getAiModelsInference } = this.props;
    let newSelectedInference = this.build_selected_Inference(selectedInference);

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">{t('inference_services.create_update_inference.title')}</h3>
            <h3 className="page-subhead subhead">{t('inference_services.create_update_inference.sub_title')}
            </h3>

            <InferenceForm
              form_data={newSelectedInference}
              onSubmit={this.handleCreate}
              getAiModelsInference={getAiModelsInference}
              setAiModel={this.setAiModel}
              onCancel={() => {
                this.closeForm();
              }}
            />

          </Col>
        </Row>
      </Container>
    );
  }
}

InferenceCreateUpdate.propTypes = {
  t: PropTypes.func.isRequired,
  createOrUpdateInference: PropTypes.func.isRequired,
};

function mapStateToProps({ assetsManagement, inference, collections }) {
  return {
    selectedAsset: assetsManagement.selectedAsset,
    selectedInference: inference.selectedInference,
    Inference_types: inference.Inference_types,
    collections,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      createOrUpdateInference,
      loadCollections,
      getAiModelsInference
    },
    dispatch
  );
}

export default withTranslation('common') (
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(InferenceCreateUpdate)
);
